<template>
  <v-container class="px-0">
    <!-- style="background-color: #f3f3f3" -->
    <!-- expand-on-hover -->
    <v-navigation-drawer
      app
      v-model="drawer"
      dark
      :permanent="$vuetify.breakpoint.mdAndUp"
      color="primary"
    >
      <template v-slot:prepend>
        <v-img
          max-height="100"
          max-width="200"
          src="@/assets/frogigo_logo1.png"
        ></v-img>
        <!-- <v-divider class="styled-hr"></v-divider> -->
      </template>
      <v-list nav class="mb-15">
        <v-list-item-group v-model="group">
          <v-list-item inactive :dense="!$vuetify.breakpoint.mdAndUp">
            <v-list-item-icon>
              <v-icon>{{ mdiAccount }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">{{
              MemberNo
            }}</v-list-item-title>
          </v-list-item>

          <v-divider class="styled-hr"></v-divider>

          <v-list-item
            :dense="!$vuetify.breakpoint.mdAndUp"
            v-for="(menuItem, i) in menuItems"
            :key="i"
            @click="showContent(menuItem.content, menuItem.label)"
          >
            <v-list-item-icon>
              <v-icon v-text="menuItem.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">
              {{ $t(menuItem.label) }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dense app color="white lighten-4" fixed elevation="2">
      <v-app-bar-nav-icon
        v-show="!$vuetify.breakpoint.mdAndUp"
        @click="showDrawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pl-0"
        ><div class="font-weight-bold">{{ title }}</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- process.env.NODE_ENV === 'production' -->
      <v-btn icon @click="sendMessage" v-if="isDevelopment">
        <v-icon color="secondary">{{ mdiFileDocumentOutline }}</v-icon>
      </v-btn>
      <v-btn icon @click="toHome" class="">
        <v-icon color="secondary">{{ mdiHome }}</v-icon>
      </v-btn>
      <v-btn icon @click="localeDialog = true" class="" v-show="false">
        <v-icon color="secondary">{{ mdiEarth }}</v-icon>
      </v-btn>
      <v-btn icon @click="openNoticeDialog" class="">
        <v-badge dot color="red" v-model="isNotify">
          <v-icon color="secondary">{{ mdiBell }}</v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon @click="logout" class="">
        <v-icon color="secondary">{{ mdiLogout }}</v-icon>
      </v-btn>
      <Language v-model="localeDialog"></Language>
    </v-app-bar>

    <v-container fluid class="pa-0">
      <component :is="mainContent"></component>
    </v-container>

    <!-- <v-footer app>

    </v-footer> -->
    <v-dialog
      v-model="notificationDialog"
      class="mx-auto"
      width="450"
      :fullscreen="fullScreenDialog"
    >
      <v-card>
        <v-row no-gutters>
          <v-col cols="4">
            <v-card-title>
              {{ $t("label.notice") }}
            </v-card-title>
          </v-col>
          <v-col cols="6">
            <v-switch
              v-model="isUnread"
              :label="getNoticeLabel"
              color="primary"
              hide-details
              @change="searchMessageNotification()"
            ></v-switch>
          </v-col>
          <v-col cols="2" class="my-auto">
            <v-btn
              color="primary"
              small
              icon
              @click="notificationDialog = false"
              class="float-right mx-6"
            >
              <v-icon>{{ mdiCloseThick }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-data-table
          :headers="noticeHeaders"
          :items="notices"
          item-key="ID"
          class="elevation-1"
          hide-default-header
          dense
          :item-class="setItemClass"
          @item-expanded="onExpand"
          :server-items-length="totalNotices"
          :loading="loadingNotices"
          :page="Page"
          :options.sync="options"
          :single-expand="true"
          show-expand
        >
          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length" class="pa-3 ma-3">
              {{ Description }}
            </td>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notificationDialog = false">
            {{ $t("label.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </v-container>
</template>

<script>
import {
  mdiAccount,
  mdiHome,
  mdiEarth,
  mdiBell,
  mdiCloseThick,
  mdiLogout,
  mdiFileDocumentOutline,
  mdiTruck,
  mdiMapMarker,
  mdiSale,
  mdiCog,
  mdiWhatsapp,
} from "@mdi/js";

import i18n from "../lang/lang";
import Language from "@/components/Language.vue";

import {
  IsAuth,
  SystemLogout,
  SearchMessageNotification,
  RetrieveMessageNotification,
  SetMessageRead,
  HasUnreadMessageNotification,
} from "@/api/publicServices";

export default {
  metaInfo: {
    title: "控制台",
    titleTemplate: "%s | 青蛙集運",
  },
  mounted() {
    this.showContent("Order", "label.order");

    //signalr testing
    if (this.isDevelopment) {
      //this.startSignalR();
    }
  },
  async created() {
    let isAuth = await this.isAuth();
    if (isAuth) {
      console.log("auth");
      this.pollData();
      this.hasUnreadMessageNotification();
      this.MemberNo = localStorage.getItem("member_no");
    } else {
      this.snackBarMsg.text = i18n.t("message.relogin");
      this.snackBarMsg.show = true;
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  components: {
    Language: Language,
    Order: () => import("@/components/Order.vue"),
    Bundle: () => import("@/components/Bundle.vue"),
    DirectDelivery: () => import("@/components/DirectDelivery.vue"),
    Warehouse: () => import("@/components/Warehouse.vue"),
    SelfPickSpot: () => import("@/components/SelfPickSpot.vue"),
    Coupon: () => import("@/components/Coupon.vue"),
    Setting: () => import("@/components/Setting.vue"),
  },
  data: () => ({
    title: "",
    message: "",
    drawer: false,
    group: null,
    localeDialog: false,
    mainContent: "Order",
    menuItems: [
      {
        content: "Order",
        label: "label.order",
        icon: mdiFileDocumentOutline,
      },
      { content: "Warehouse", label: "label.warehouse", icon: mdiHome },
      {
        content: "DirectDelivery",
        label: "label.direct_delivery_address",
        icon: mdiTruck,
      },
      {
        content: "SelfPickSpot",
        label: "label.self_pick_spot",
        icon: mdiMapMarker,
      },
      { content: "Coupon", label: "label.coupon", icon: mdiSale },
      { content: "Setting", label: "label.setting", icon: mdiCog },
      { content: "WhatsApp", label: "label.whatsapp", icon: mdiWhatsapp },
    ],
    notificationDialog: false,
    isNotify: false,
    isUnread: false,
    PageSize: 10,
    Page: 1,
    loading: false,
    transition: "scale-transition",
    notices: [],
    Description: "",
    totalNotices: 0,
    options: {},
    loadingNotices: true,
    MemberNo: "",
    polling: null,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiAccount,
    mdiHome,
    mdiEarth,
    mdiBell,
    mdiCloseThick,
    mdiLogout,
    mdiFileDocumentOutline,
    mdiTruck,
    mdiMapMarker,
    mdiSale,
    mdiCog,
    mdiWhatsapp,
  }),
  watch: {
    group() {
      this.drawer = false;
    },
    options: {
      handler() {
        this.searchMessageNotification();
      },
      deep: true,
    },
  },
  methods: {
    async isAuth() {
      try {
        const response = await IsAuth();
        return response.data;
      } catch (error) {
        console.log(error);
      }
    },
    showDrawer() {
      this.drawer = true;
    },
    showContent(content, title) {
      console.log(title);
      if (content === "WhatsApp") {
        window.open("https://wa.me/85267470369", "_blank");
      } else {
        this.title = i18n.t(title);
        this.mainContent = content;
      }
    },
    async logout(e) {
      e.preventDefault();
      localStorage.removeItem("member_no");
      localStorage.removeItem("access_token");
      try {
        const response = await SystemLogout();
        if (response.data.isSuccess) {
          this.$router.push({ name: "home" }).catch(() => {});
        } else {
          this.$router.push({ name: "home" }).catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$router.push({ name: "home" }).catch(() => {});
      }
    },
    isLogin() {
      return (
        localStorage["member_no"] != undefined &&
        localStorage["member_no"] != ""
      );
    },
    toHome() {
      this.$router.push({ name: "home" }).catch(() => {});
    },
    sendMessage() {
      console.log("send message");
      window.open("https://d.dts-log.com/frogigo/deeplink/abc", "_blank");
      //this.$notificationHub.sendMessage("frogigo", "hello world!");
    },
    async searchMessageNotification() {
      this.loading = true;
      let data = {};

      data.Readsw = this.isUnread;

      data.PageSize = this.PageSize;
      data.PageNum = this.options.page;

      try {
        const response = await SearchMessageNotification(data);
        this.notices = response.data.Results;
        this.totalNotices = response.data.Total;
        this.loadingNotices = false;
        this.isNotify = response.data.Read;
      } catch (error) {
        console.log(error);
      }
    },
    async retrieveMessageNotification(ID) {
      let data = {};
      data.ID = ID;
      try {
        let response = await RetrieveMessageNotification(data);
        this.Description = response.data.Description;
      } catch (error) {
        console.log(error);
      }
    },
    async setMessageRead(ID) {
      let data = {};
      data.ID = ID;
      try {
        await SetMessageRead(data);
        this.hasUnreadMessageNotification();
      } catch (error) {
        console.log(error);
      }
    },
    setItemClass(item) {
      if (item.ReadDate == "") {
        return "unread";
      }
    },
    onExpand(event) {
      if (event.value) {
        let item = event.item;

        this.retrieveMessageNotification(item.ID);

        if (item.ReadDate == "") {
          this.setMessageRead(item.ID);
          item.ReadDate = "readed";
        }
      }
    },
    openNoticeDialog() {
      let currentPage = this.options.page;
      this.options.page = 1;
      this.notices = [];
      this.totalNotices = 0;
      this.Page = 1;
      this.notificationDialog = true;
      if (currentPage == 1) {
        this.searchMessageNotification();
      }
    },
    async hasUnreadMessageNotification() {
      try {
        let response = await HasUnreadMessageNotification();
        this.isNotify = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    pollData() {
      this.polling = setInterval(() => {
        console.log("pollData");
        this.hasUnreadMessageNotification();
      }, 900000);
    },
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    fullScreenDialog() {
      return localStorage.getItem("flutter") == "true";
    },
    getNoticeLabel() {
      if (!this.isUnread) {
        return i18n.t("label.unread");
      } else {
        return i18n.t("label.read");
      }
    },

    noticeHeaders() {
      return [{ value: "Title" }, { value: "IssueDate", class: "notice-date" }];
    },
  },
};
</script>
<style>
.styled-hr {
  margin-bottom: 8px;
  border: 1px solid #ddd !important;
  background-color: #ddd !important;
}
</style>
